import axios from "axios";
// Entities
import { OrdersPerDays } from "@/entities/index";

export async function getOrdersPerDays({
  client,
  warehouse,
}: {
  client: string;
  warehouse: string;
}): Promise<{ orderStatus: string[]; currentOrdersStatus: number[] }> {
  const { orderStatus, currentOrdersStatus } = (
    await axios.post(`/api/dashboards/chart4`, {
      client,
      warehouse,
    })
  ).data as OrdersPerDays;

  return { orderStatus, currentOrdersStatus };
}
